import Vue from 'vue';
import Vuex from 'vuex';
import applications from './modules/applications';
import lightbox from './modules/lightbox';
import companies from './modules/companies';
import maps from './modules/maps';
import referrals from './modules/referrals';
import profiles from './modules/profiles';
import quickbooks from './modules/quickbooks';
import xero from './modules/xero';
import bookedLoads from './modules/bookedLoads';
import dispatchRequests from './modules/dispatchRequests';
import loadTransactions from './modules/loadTransactions';
import plannedLoads from './modules/plannedLoads';
import repeatingLoadTemplates from './modules/repeatingLoadTemplates';
import spaceTime from './modules/spaceTime';
import plugins from './modules/plugins';

import bids from './modules/bids';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    applications,
    companies,
    maps,
    profiles,
    referrals,
    lightbox,
    quickbooks,
    xero,
    bookedLoads,
    dispatchRequests,
    loadTransactions,
    plannedLoads,
    repeatingLoadTemplates,
    bids,
    spaceTime,
    plugins,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js